import REGEX from './regex.js';

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

export default validate;


//////////////////
// WEBPACK FOOTER
// /var/www/html/web/app/themes/wakanda/node_modules/uuid/dist/esm-browser/validate.js
// module id = 3
// module chunks = 0 1 2 3 4 5 6 7 8